import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  ModalWrapper,
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  IconAndTitle,
  Separator,
  Title,
} from "./styles";

const OTPModal = ({ open, handleClose, children, icon, title, fromSignup = false, width }) => {
  const defaultWidth = width ?? "450px"
  return (
    <ModalWrapper>
      <StyledDialog 
        open={open} 
        onClose={(event, reason) => {
          if(fromSignup && reason === "backdropClick") return;

          handleClose();
        }}
        fromSignup={fromSignup}
        maxWidth={fromSignup ? false : defaultWidth}
        hideBackdrop={fromSignup || false}
        disablePortal={fromSignup || false}
        disableEscapeKeyDown={fromSignup}
      >
        <StyledDialogTitle>
            <IconAndTitle>
                {icon && (
                  <img src={icon} alt="otp" width={32} height={40} />
                )}
                <Title>{title}</Title>
          </IconAndTitle>
          {!fromSignup && (
            <CloseIcon className="close-icon" onClick={handleClose} />
          )}
        </StyledDialogTitle>
        <Separator />
        <StyledDialogContent>
            {children}
        </StyledDialogContent>
      </StyledDialog>
    </ModalWrapper>
  );
};

export default OTPModal;
